import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import { Users, VUsers } from '../../../../model/structures';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import Validation from '../../../../utils/validation';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MustMatch } from '../../../../_helpers/must-match.validator';
import {
  faShieldHalved,
  faPen,
  faEnvelope,
  faPhone,
  faShield,
  faBoxArchive,
  faUser,
  faLayerGroup
} from '@fortawesome/free-solid-svg-icons';
import { MatTableDataSource } from '@angular/material/table';
import { Sort, MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { VGroups } from '../../../../model/structures';
import { MasterService } from 'src/app/services/master.service';
import { AuthenticationService } from '../../../../services/authentication.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-cal-remove-confirm',
  templateUrl: './cal-remove-confirm.component.html',
  styleUrls: ['./cal-remove-confirm.component.css']
})
export class CalRemoveConfirmComponent implements OnInit {
//submitted = false;
  //remove_confirm_form:FormGroup;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CalRemoveConfirmComponent>,
  ) { }

  ngOnInit(): void {
  }

  //----------------------------------------------------
  onSubmit(_result: boolean): void {

    this.dialogRef.close({ submitted: _result });
  }

}
